
import { defineComponent } from 'vue'

import Loader from '@/common/components/UI/Loader/index.vue'

export default defineComponent({
    components: {
        loader: Loader,
    },
    props: {
        isNotFound: {
            type: Boolean,
            default: false
        },
        notFoundMessage: {
            type: String,
            default: null
        },
        isInProgress: {
            type: Boolean,
            default: false
        }
    }
})
